import { styled } from '@mui/material/styles';

import { px, rem, Theme } from '../../theme';

import { StyledChipWrapperProperties } from './Chip.types';

export const ChipWrapper = styled('span')<StyledChipWrapperProperties>`
    ${({ theme }: { theme: Theme }) => theme.typography.text_12_lh_18};
    ${({ theme }: { theme: Theme }) => `
        box-sizing: border-box;
        display: inline-block;
        height: ${theme.tggSpacing(rem(2), 6)};
        padding: ${theme.tggSpacing([0, rem(0.7)], [0, 3])};
        color: ${theme.palette.common.blue};
        text-transform: lowercase;
        vertical-align: middle;
        border: ${theme.tggSpacing(px(1), 0.25)} solid;
        border-color: ${theme.palette.common.blue};
        /* temporary fix */
        line-height: ${theme.tggSpacing(rem(1.8), rem(1.4))};
        border-radius: ${theme.tggSpacing(rem(1), 2.5)};
	`}
`;
